import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { Profile } from '@/types/supabase';
import ChannelManagementCard from './ChannelManagementCard'; // Import the new component

const LobbySettings = () => {
  const { toast } = useToast();
  const [allUsers, setAllUsers] = useState<Profile[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(true);

  const fetchAllUsers = useCallback(async () => {
    const { data, error } = await supabase.from('profiles').select('id, full_name, username');
    if (error) {
      toast({ title: 'Error', description: 'Could not fetch users.', variant: 'destructive' });
      return [];
    }
    return data as Profile[];
  }, [toast]);

  useEffect(() => {
    const initialize = async () => {
      setLoadingUsers(true);
      const users = await fetchAllUsers();
      setAllUsers(users);
      setLoadingUsers(false);
    };
    initialize();
  }, [fetchAllUsers]);

  if (loadingUsers) return <div className="flex justify-center items-center p-8"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="space-y-6">
      <ChannelManagementCard
        channelSlug="investors"
        channelName="Investors"
        channelDescription="Manage user access and features for the private #investors channel."
        allUsers={allUsers}
      />
      <ChannelManagementCard
        channelSlug="affiliate"
        channelName="Affiliate"
        channelDescription="Manage user access and features for the private #affiliate channel."
        allUsers={allUsers}
      />
    </div>
  );
};

export default LobbySettings;